export default __webpack_public_path__ + "static/media/icon_imaging.70333f98.svg";